import React from 'react';
import { Redirect, Route } from 'react-router';
import { unsetToken } from './../services/auth';
import { ID_LAST_ROUTE } from './../config/constants';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest}) => {

    const profile = useSelector(state => state.auth.profile);
    return (
        <Route {...rest} render={props => {
            
            if (profile._id){
                return <Component {...props} />;
            } else {
                unsetToken();   
                localStorage.setItem(ID_LAST_ROUTE, props.location.pathname);
                return <Redirect to="/restrita" />
            }
        }} />
    );
}

export default PrivateRoute;